import styled from "styled-components";

export const BottomNavigationBarBadgeBox = styled.div`
  position: absolute;
  right: -18px;
  background-color: ${props => props.theme.colors.exploreHighlight};
  color: ${props => props.theme.colors.textLight};
  border-radius: 16px;
  padding: 2px 8px;
`;